import type { ComponentProps } from 'react'
import AuditHistoryTimeline from './AuditHistoryTimeline'

export function AuditHistory(props: ComponentProps<typeof AuditHistoryTimeline>) {
  return <AuditHistoryTimeline {...props} />
}
